export default  {
  apiKey: "AIzaSyAK-SnktrTS1-xIdacnSEBWDteoY4t2-aM",
  authDomain: "consume-cannabis.firebaseapp.com",
  databaseURL: "https://consume-cannabis.firebaseio.com",
  projectId: "consume-cannabis",
  storageBucket: "consume-cannabis.appspot.com",
  messagingSenderId: "1031799709036",
  appId: "1:1031799709036:web:267b5a127aef3ee021e749",
  measurementId: "G-6C62W011D0"
};
